import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
// Import Containers
import { DefaultLayoutComponent } from './containers';
import { P404Component } from './views/error/404.component';
import { P500Component } from './views/error/500.component';
import { LoginComponent } from './views/login/login.component';
import { ReportComponent } from './views/task/report/report.component';
import { ReportStoreComponent } from './views/task/report/reportstore.component';
import { ReportStoreInstructionComponent } from './views/task/report/reportstoreinstruction.component';
import { ReportStorePriceChangeComponent } from './views/task/report/reportstorepricechange.component';
import { ReportStorePriceAdvanceComponent } from './views/task/report/reportstorepriceadvance.component';
import { ReportStoreInventoryComponent } from './views/task/report/reportstoreinventory.component';
import { AdminComponent } from './views/adminChecklist/admin.component';
import { ChecklistComponent } from './views/adminChecklist/checklist/checklist.component';
import { AuthGuard } from './auth.guard';
import { PendingChangesGuard } from './common/util/pending-changes.guard';
import { OrganizationChartComponent } from './views/configuration/organization-chart/organization-chart.component';
import { OrganizationChartDetailComponent } from './views/configuration/organization-chart-detail/organization-chart-detail.component';
import { ReceptionsComponent } from './views/inventory/receptions/receptions.component';
import { ReceptionsDetailComponent } from './views/inventory/receptions-detail/receptions-detail.component';
import { ShipmentsComponent } from './views/inventory/shipments/shipments.component';
import { InventoryEntryComponent } from './views/inventory/inventory-entry/inventory-entry.component';
import { InventoryEntryDetComponent } from './views/inventory/inventory-entry-det/inventory-entry-det.component';
import { PackageReceptionComponent } from './views/inventory/package-reception/package-reception.component';
import { StoresComponent } from './views/configuration/stores/stores.component';
import { EmployeeAdminComponent } from './views/configuration/employee-admin/employee-admin.component';
import { DeviceAdminComponent } from './views/configuration/device-admin/device-admin.component';
import { TemplateComponent } from './views/template/template.component';
import { ActionDetailComponent } from './views/instruction-action/action-detail/action-detail.component';
import { ActionStoreComponent } from './views/instruction-action/action-store/action-store.component';
import { TransferCorporateComponent } from './views/transfer/transfer-corporate/transfer-corporate.component';
import { TransferStoreComponent } from './views/transfer/transfer-store/transfer-store.component';
import { TransferCorporateDetailComponent } from './views/transfer/transfer-corporate-detail/transfer-corporate-detail.component';
import { TransferStoreDetailComponent } from './views/transfer/transfer-store-detail/transfer-store-detail.component';
import { TransferStoreEntryComponent } from './views/transfer/transfer-store-entry/transfer-store-entry.component';
import { TransferStoreEntryDetailComponent } from './views/transfer/transfer-store-entry-detail/transfer-store-entry-detail.component';
import { InventoryCountComponent } from './views/inventory/inventory-count/inventory-count.component';
import { InventoryCountCreateComponent } from './views/inventory/inventory-count-create/inventory-count-create.component';
import { InventoryCountDetailComponent } from './views/inventory/inventory-count-detail/inventory-count-detail.component';
import { ReturnCorporateComponent } from './views/return/return-corporate/return-corporate.component';
import { ReturnRequestComponent } from './views/return/return-request/return-request.component';
import { ReturnRequestDetailComponent } from './views/return/return-request/return-request-detail/return-request-detail.component';
import { ReturnStoreComponent } from './views/return/return-store/return-store.component';
import { ReturnStoreDetailComponent } from './views/return/return-store/return-store-detail/return-store-detail.component';
import { ShipmentsAsnComponent } from './views/inventory/shipments-asn/shipments-asn.component';
import { shipmentsAsnDetailComponent } from './views/inventory/shipments-asn-detail/shipments-asn-detail.component';
import { ShipmentsAsnVarietyDetailComponent } from './views/inventory/shipments-asn-variety-detail/shipments-asn-variety-detail.component';
import { StoreReportComponent } from './views/store/store-report/store-report.component';
import { StoreReportDetailComponent } from './views/store/store-report-detail/store-report-detail.component';
import { StoreReportChecklistComponent } from './views/store/store-report-checklist/store-report-checklist.component';
import { ZoneAdminComponent } from './views/configuration/zone-admin/zone-admin.component';
import { ModuleAdminComponent } from './views/configuration/module-admin/module-admin.component';
import { TranferConsignmentComponent } from './views/transfer/tranfer-consignment/tranfer-consignment.component';
import { RestockNewComponent } from './views/restock/restock-new/restock-new.component';
import { RestockReportComponent } from './views/restock/restock-report/restock-report.component';
import { InventoryPreironedComponent } from './views/inventory/inventory-preironed/inventory-preironed.component';

import { ImageCollectorComponent } from './views/image-collector/image-collector.component';
import { PriceLabelComponent } from './views/configuration/price-label/price-label.component';
import { InvoicementDownloadComponent } from './views/inventory/invoicement-download/invoicement-download.component';
import { LoggerLayoutsComponent } from './views/configuration/logger-layouts/logger-layouts.component';
import { UsersAdminComponent } from './views/configuration/admin-users/users-admin/users-admin.component';
import { AdminRolesComponent } from './views/configuration/admin-roles/admin-roles/admin-roles.component';
import { UnsoldItemSizeComponent } from './views/inventory/unsold-item-size/unsold-item-size.component';
import { title } from 'process';

export const routes: Routes = [
    {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
    },
    {
        path: '404',
        component: P404Component,
        data: {
            title: 'Page 404'
        }
    },
    {
        path: '500',
        component: P500Component,
        data: {
            title: 'Page 500'
        }
    },
    {
        path: 'login',
        component: LoginComponent,
        data: {
            title: 'Login'
        }
    },
    {
        path: '',
        component: DefaultLayoutComponent,
        canActivate: [AuthGuard],
        data: {
            title: 'Inicio'
        },
        children: [
            {
                path: 'views/task/report',
                data: {
                    title: 'Reporte Actividades'
                },
                children: [
                    {
                        path: '',
                        component: ReportComponent
                    },
                    {
                        path: 'store',
                        data: {
                            title: 'Detalle Por Tienda'
                        },
                        children: [
                            {
                                path: '',
                                component: ReportStoreComponent,
                            },
                            {
                                path: 'instruction',
                                component: ReportStoreInstructionComponent,
                                data: {
                                    title: 'Instrucciones'
                                }
                            },
                            {
                                path: 'pricechange',
                                component: ReportStorePriceChangeComponent,
                                data: {
                                    title: 'Cambio de Precios',
                                }
                            },
                            {
                                path: 'priceadvance',
                                component: ReportStorePriceAdvanceComponent,
                                data: {
                                    title: 'Avance'
                                }
                            },
                            {
                                path: 'inventory',
                                component: ReportStoreInventoryComponent,
                                data: {
                                    title: 'Inventario'
                                }
                            }
                        ]
                    }
                ]
            },
            {
                path: 'StoreReport',
                component: StoreReportComponent,
                data: {
                    title: 'Reporte Tiendas'
                }
            },
            {
                path: 'store-report-detail/:storeId/:taskTypeId/:startDate/:endDate/:organizationId',
                component: StoreReportDetailComponent,
                data: {
                    title: 'Detalle de Reporte de Tienda'
                }
            },
            /*
            {
                path: 'StoreReportCheckList',
                component: StoreReportChecklistComponent,
                data: {
                    title: 'Reporte CheckList'
                }
            },
            */
            {
                path: 'actions',
                component: ActionStoreComponent,
                data: {
                    title: 'Acciones Correctivas'
                }
            },
            {
                path: 'actions-detail',
                component: ActionDetailComponent,
                data: {
                    title: 'Detalle Acciones Correctivas'
                }
            },
            {
                path: 'admin',
                component: AdminComponent,
                data: {
                    title: 'Administrador de Checklist'
                }
            },
            {
                path: 'template',
                component: TemplateComponent,
                data: {
                    title: 'Administrador de plantillas'
                }
            },
            {
                path: 'admin/checklist',
                component: ChecklistComponent,
                data: {
                    title: 'Programar Checklist'
                }
            },
            {
                path: 'return/return-corporate',
                component: ReturnCorporateComponent,
                data: {
                    title: 'Devoluciones Programadas'
                }
            },
            {
                path: 'return/return-request',
                component: ReturnRequestComponent,
                data: {
                    title: 'Solicitudes de Devolución por Defecto'
                }
            },
            {
                path: 'return/return-request/detail/:id',
                component: ReturnRequestDetailComponent,
                data: {
                    title: 'Detalle solicitud'
                }
            },
            {
                path: 'return/return-store',
                component: ReturnStoreComponent,
                data: {
                    title: 'Devoluciones por Defecto'
                }
            },
            {
                path: 'return/return-store/detail/:id',
                component: ReturnStoreDetailComponent,
                data: {
                    title: 'Detalle devolución'
                }
            },
            {
                path: 'dashboard',
                loadChildren: () => import('./views/dashboard/dashboard.module').then(m => m.DashboardModule)
            },
            {
                path: 'config/stores/detail',
                loadChildren: () => import('./views/configuration/stores-detail/stores.module').then(m => m.StoresModule)
            },
            {
                path: 'config/organization-chart',
                component: OrganizationChartComponent,
                data: {
                    title: 'Configuración de estructura organizacional'
                }
            },
            {
                path: 'config/organization-chart/:id',
                component: OrganizationChartDetailComponent,
                data: {
                    title: 'Detalle estructura organizacional'
                }
            },
            {
                path: 'inventory/receptions',
                component: ReceptionsComponent,
                data: {
                    title: 'Historial de recepciones'
                }
            },
            {
                path: 'inventory/receptions-detail/:id',
                component: ReceptionsDetailComponent,
                data: {
                    title: 'Detalle de recepción'
                }
            },
            /* {
                path: 'inventory/shipments',
                component: ShipmentsComponent,
                data: {
                    title: 'Historial de embarques'
                }
            }, */
            {
                path: 'inventory/inventory-entry/:id',
                component: InventoryEntryComponent,
                data: {
                    title: 'Entradas a inventario'
                }
            },
            {
                path: 'inventory/inventory-entry-det/:id',
                component: InventoryEntryDetComponent,
                data: {
                    title: 'Entradas a inventario'
                }
            },
            {
                path: 'inventory/package-reception/:id',
                component: PackageReceptionComponent,
                data: {
                    title: 'Recepcion de paquetes'
                }
            },
            {
                path: 'inventory/unsold-item-size',
                component: UnsoldItemSizeComponent,
                data: {
                    title: 'Artículos negados para venta'
                }
            },
            {
                path: 'config/stores',
                component: StoresComponent,
                data: {
                    title: 'Configuracion de tiendas'
                }
            },
            {
                path: 'config/employee-admin',
                component: EmployeeAdminComponent,
                data: {
                    title: 'Configuracion de tiendas'
                }
            },
            {
                path: 'config/device-admin',
                component: DeviceAdminComponent,
                data: {
                    title: 'Administrador de Dispositivos'
                }
            },
            {
                path: 'config/zone-admin',
                component: ZoneAdminComponent,
                data: {
                    title: 'Administrador de Zonas/Región'
                }
            },
            {
                path: 'transfer/corporate',
                component: TransferCorporateComponent,
                canDeactivate: [PendingChangesGuard],
                data: {
                    title: 'Traspasos Corporativo'
                }
            },
            {
                path: 'transfer/consigment',
                component: TranferConsignmentComponent,
                data: {
                    title: 'Traspaso en Transito'
                }
            },
            {
                path: 'transfer/store',
                component: TransferStoreComponent,
                data: {
                    title: 'Traspasos Tienda'
                }
            },
            {
                path: 'transfer/corporate/:id',
                component: TransferCorporateDetailComponent,
                data: {
                    title: 'Detalle traspaso corporativo'
                }
            },
            {
                path: 'transfer/store/:id',
                component: TransferStoreDetailComponent,
                data: {
                    title: 'Detalle traspaso tienda'
                }
            },
            {
                path: 'transfer/store/entry/:id',
                component: TransferStoreEntryComponent,
                data: {
                    title: 'Ingresos parciales en traspaso a tienda'
                }
            },
            {
                path: 'transfer/store/entry/detail/:id',
                component: TransferStoreEntryDetailComponent,
                data: {
                    title: 'Ingreso parcial detallado (traspaso a tienda)'
                }
            },
            {
                path: 'inventory/counts',
                data: {
                    title: 'Listado inventarios físicos'
                },
                children: [
                    {
                        path: 'physical',
                        component: InventoryCountComponent,      
                    },
                    {
                        path: 'physical/:id',
                        component: InventoryCountCreateComponent,
                        data: {
                            title: 'Crear inventarios físicos'
                        }
                    },
                    {
                        path: 'physical/detail/:id',
                        component: InventoryCountDetailComponent,
                        data: {
                            title: 'Detalle inventarios físicos'
                        }
                    },
                    {
                        path: 'pressed',
                        component: InventoryPreironedComponent,
                        data: {
                            title: 'Pre-planchado de invetario'
                        }
                    }
                ]
            },
            {
                path: 'inventory',
                data:{
                    title: 'Inventario'
                },
                children: [
                     {
                        path: 'shipments',
                        component: ShipmentsComponent,
                        data: {
                            title: 'Historial de embarques'
                        }
                    },
                    {
                        path: 'inventory-entry/:id',
                        component: InventoryEntryComponent,
                        data: {
                            title: 'Entradas a inventario'
                        }
                    },
                    {
                        path: 'shipments-asn',
                        component: ShipmentsAsnComponent,
                        data: {
                            title: 'Inventario Mercancia ASN'
                        }
                    },
                    {
                        path: 'shipments-asn-detail/:code',
                        component: shipmentsAsnDetailComponent,
                        data: {
                            title: 'Detalle ASN'
                        }
                    },
                    {
                        path: 'shipments-asn-variety-detail/:id',
                        component: ShipmentsAsnVarietyDetailComponent,
                        data: {
                            title: 'Detalle Variedad ASN'
                        }
                    },
                ]
            },
            /* {
                path: 'inventory/shipments-asn',
                component: ShipmentsAsnComponent,
                data: {
                    title: 'Inventario Mercancia ASN'
                }
            },
            {
                path: 'inventory/shipments-asn-detail/:code',
                component: shipmentsAsnDetailComponent,
                data: {
                    title: 'Detalle ASN'
                }
            }, */
            /*
            {
                path: 'invoicement/report',
                component: InvoicementDownloadComponent,
                data: {
                    title: 'Facturación'
                }
            },
            */
            {
                path: 'config/module-admin',
                component: ModuleAdminComponent,
                data: {
                    title: 'Administrador de Módulos'
                }
            },
            {
                path: 'restock/restock-new',
                component: RestockNewComponent,
                data: {
                    title: 'Restock'
                }
            },
            {
                path: 'restock/restock-report',
                component: RestockReportComponent,
                data: {
                    title: 'Restock Report'
                }
            },
            {
                path: 'image-collector',
                component: ImageCollectorComponent,
                data: {
                    title: 'Coleccionador de imagenes'
                }
            },
            {
                path: 'config/price-label',
                component: PriceLabelComponent,
                data: {
                    title: 'Diseño de Etiquetas'
                }
            },
            {
                path: 'config/logger-layouts',
                component: LoggerLayoutsComponent,
                data: {
                    title: 'Logger Layouts'
                }
            },
            {
                path: 'config/users-admin',
                component: UsersAdminComponent,
                data: {
                    title: 'User Administration'
                }
            },
            {
                path: 'config/roles-admin',
                component: AdminRolesComponent,
                data: {
                    title: 'Role Administration'
                }
            }
        ]
    },
    { path: '**', component: P404Component }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
    exports: [RouterModule]
})
export class AppRoutingModule { }
